<template>
<v-combobox ref="combo" v-model="internalValue" :filter="customFilter" :items="items" :readonly="!personId" maxLength="30" label="بابت/توسط" v-bind="$attrs" v-on="$listeners" :search-input.sync="search" prepend-inner-icon="mdi-account-arrow-left"
  :error="offline" :error-messages="offline ? ['اتصال به سرور برقرار نیست'] : []" item-text="title" item-value="value">
  <!-- ITEM (مثل مثال Vuetify) -->
  <template v-slot:item="data">
  <template v-if="typeof data.item !== 'object'">
    <v-list-item-content v-text="data.item"></v-list-item-content>
  </template>

  <template v-else>
    <v-list-item-content>

      <v-list-item-title class="d-flex align-center">

        {{ data.item.title }}


      </v-list-item-title>

      <v-list-item-subtitle v-if="data.item.mobile">
        {{ data.item.mobile }}
        <v-icon
        v-if="data.item.mobile"
        small
        class="mt-2"
        color="green"
        >
        mdi-phone
      </v-icon>
      </v-list-item-subtitle>

    </v-list-item-content>
  </template>
</template>


</v-combobox>
</template>

<script>
import _ from 'lodash'
import vueAxios from '../functions/vueAxios'

export default {
  name: 'MyAbouts',
  props: ['value', 'personId'],
  data() {
    return {
      internalValue: this.value || '',
      items: [],
      search: '',
      loadedOnce: false,
      offline: false,
      debouncedFetch: null,
      initialized: false
    }
  },
  watch: {
    value(val) {
      // همزمانی مقدار داخلی با prop
      this.internalValue = val || ''
      // اگر هنوز داده نیامده ولی personId هست → بلافاصله واکشی کن
      if (this.personId && !this.loadedOnce) {
        this.retrieveData()
      }
    },
    internalValue(val) {
      const isObject = typeof val === 'object' && val

      this.$emit('input', isObject ? val.title : val || '')

      // 👇 این خط جدید برای موبایل
      this.$emit('select', isObject ? val : null)
    },
    // internalValue(val) {
    //   const safeValue =
    //     typeof val === 'object' && val ?
    //     val.title :
    //     val
    //
    //   this.$emit('input', safeValue || '')
    // },
    personId(newVal) {
      // this.items = []
      // this.search = ''
      // this.loadedOnce = false
      // this.offline = false
      // this.internalValue = this.value || ''
      if (newVal) {
        this.retrieveData()
      }
    },
    search(val) {
      if (!this.initialized) return
      if (this.personId && val !== undefined) {
        this.debouncedFetch()
      }
    }
  },
  created() {
    this.debouncedFetch = _.debounce(this.retrieveData.bind(this), 500)
    this.$nextTick(() => this.initialized = true)
    if (this.personId) this.retrieveData()
  },
  methods: {
    async retrieveData() {
      if (!this.personId) {
        this.items = []
        return
      }
      this.offline = false
      try {
        const res = await vueAxios.get('/persons/abouts', {
          params: {
            mid: this.personId,
            q: this.search || ''
          }
        })

        if (res && Array.isArray(res)) {
          // فقط رشته‌ها رو نگه می‌داریم
          // this.items = res.map(item => item.title)
          // console.log(JSON.stringify(res));
          // this.items = res
          this.items = res.map(item => ({
            title: item.title,
            mobile: item.mobile,
            value: item.mobile ?
              `${item.title}-${item.mobile}` :
              item.title
          }))
          // بعد از آماده شدن داده‌ها مقدار انتخابی والد رو ست کن
          this.$nextTick(() => {
            this.internalValue = this.value || ''
          })
        } else {
          this.items = []
          this.offline = true
          console.warn('داده API معتبر نیست:', res)
        }
      } catch (e) {
        console.error('خطا در دریافت داده:', e)
        this.items = []
        this.offline = true
      } finally {
        this.loadedOnce = true
        this.$nextTick(() => {
          if (this.$refs.combo) {
            this.$refs.combo.validate(true)
          }
        })
      }
    },
    customFilter(item, queryText) {
      const q = queryText.toLowerCase()

      return (
        (item.title && item.title.toLowerCase().includes(q)) ||
        (item.mobile && item.mobile.toLowerCase().includes(q))
      )
    },
  }
}
</script>
